import React from 'react';

const PlusIcon: React.FC = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.2499 7.5H10.5V0.75C10.5 0.335625 10.1643 0 9.74996 0H8.24997C7.8356 0 7.49997 0.335625 7.49997 0.75V7.5H0.749998C0.335624 7.5 0 7.83563 0 8.25V9.75C0 10.1644 0.335624 10.5 0.749998 10.5H7.49997V17.25C7.49997 17.6644 7.8356 18 8.24997 18H9.74996C10.1643 18 10.5 17.6644 10.5 17.25V10.5H17.2499C17.6643 10.5 17.9999 10.1644 17.9999 9.75V8.25C17.9999 7.83563 17.6643 7.5 17.2499 7.5Z"
                fill="#01336B"
            />
        </svg>
    );
};

export default PlusIcon;
